import { Box, Popover, Typography } from "@mui/material";
import * as React from "react";

interface Props {
  anchorEl: any;
  setAnchorEl: Function;
  selectAllOrganizationsChecked: boolean;
  setSelectAllOrganizationsChecked: Function;
  patientsCount: string;
  organizationsCount: string | number;
}

const PatientsAdvancedFilters: React.FC<Props> = ({
  anchorEl,
  setAnchorEl,
  selectAllOrganizationsChecked,
  setSelectAllOrganizationsChecked,
  patientsCount,
  organizationsCount,
}) => {
  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const clearAllFilters = () => {
    setSelectAllOrganizationsChecked(false);
    handleClose();
  };

  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
    >
      <div className="popover-filter-container ">
        <div className="header-wrapper">
          <div className="header">Patients Filters</div>
          <button onClick={clearAllFilters} className="clear-all">
            <svg
              width="9"
              height="9"
              viewBox="0 0 8 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                y="7.99902"
                width="8"
                height="8"
                rx="1"
                transform="rotate(-90 0 7.99902)"
                fill="#FF890A"
              />
              <path
                d="M2.13699 1.66585L1.66699 2.13585L3.53033 3.99919L1.66699 5.86252L2.13699 6.33252L4.00033 4.46919L5.86366 6.33252L6.33366 5.86252L4.47033 3.99919L6.33366 2.13585L5.86366 1.66585L4.00033 3.52919L2.13699 1.66585Z"
                fill="white"
              />
            </svg>
            <span>Clear All</span>
          </button>
        </div>
        <div
          style={{
            paddingLeft: "20px",
            marginTop: "3px",
          }}
        >
          <Typography
            sx={{
              color: "#A29D9B",
              fontSize: "10px",
              lineHeight: "16px",
            }}
          >
            {patientsCount} Patients
          </Typography>
        </div>

        <div
          className="tag-number"
          style={{
            marginTop: "10px",
            display: "flex",
            whiteSpace: "nowrap",
            alignItems: "center",
            backgroundColor: "#F8F8F8",
            height: "45px",
            paddingLeft: "17px",
          }}
        >
          <div className="multiple-checkbox">
            <div
              className="checkbox-row-container"
              style={{ marginBottom: "0px" }}
            >
              <label className="option-text" style={{ alignItems: "center" }}>
                <input
                  type="checkbox"
                  name="all_organizations"
                  checked={selectAllOrganizationsChecked}
                  onChange={(e) =>
                    setSelectAllOrganizationsChecked(e.target.checked)
                  }
                  className="checkbox"
                />
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    columnGap: "4px",
                  }}
                >
                  Select All Organizations{""}
                  <Box
                    sx={{
                      backgroundColor: "#EFE9E7",
                      color: "#1E1E1E",
                      height: "16px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "8px",
                      fontWeight: 600,
                      lineHeight: "16px",
                      padding: "0px 7px",
                      borderRadius: "80px",
                    }}
                  >
                    {organizationsCount}
                  </Box>
                </div>
              </label>
            </div>
          </div>
        </div>
      </div>
    </Popover>
  );
};

export default PatientsAdvancedFilters;
